export const LOCAL_AUTH_TOKEN = 'advisor-local-development'
export const LOCAL_AUTH_USER = {
  id: '00000000-0000-4000-8000-000000000001',
  displayName: 'Local Developer',
  givenName: 'Local',
  surname: 'Developer',
  mail: 'local.developer@securitas.example.test',
  userPrincipalName: 'local.developer@securitas.example.test',
}

export function isLocalAuthEnabled(
  development: boolean,
  enabled: boolean,
  hostname: string,
  endpoint: string | undefined,
): boolean {
  const loopback = (host: string) => ['localhost', '127.0.0.1', '[::1]'].includes(host)
  if (!development || !enabled || !loopback(hostname) || !endpoint)
    return false
  try {
    const url = new URL(endpoint)
    return ['http:', 'https:'].includes(url.protocol) && loopback(url.hostname)
  }
  catch {
    return false
  }
}

export function isPublicLocalAuthRoute(pathname: string, search: string): boolean {
  return pathname.startsWith('/web-report/')
    || (pathname.includes('report') && new URLSearchParams(search).has('reportAccessToken'))
}
